import { AgmMap } from '@agm/core';
import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'location-contact-card',
  templateUrl: 'location-contact-card.component.html'
})
export class LocationContactCardComponent {
  @Input() contactCard: any;
  @Input() iconType: string;
  @ViewChild(AgmMap) public agmMap: AgmMap;
  toggle: boolean;

  public clickMap(event: any) {
    if (this.contactCard != null && this.contactCard.Address != null)
      window.open(this.contactCard.Address.GoogleMapsUrl, '_blank');
  }

  public refreshMap() {
    this.agmMap.triggerResize();
  }

  getIconValue(): boolean {
    if (this.iconType == 'Venue') {
      return true;
    } else if (this.iconType == 'Location') {
      return false;
    } else {
      return true;
    }
  }
}
